import pictureAnim from './picture';
import sponsorLogo from './sponsorLogo';
import { qs } from '@/scripts/utils';

const pictureIn = (el) => {
  const anim = el.node.getAttribute('js-anim');
  el.node.removeAttribute('js-anim');

  const picture = qs('div[js-target="pictureimg"]', el.node);
  const img = qs('img[js-target="pictureimg"]', el.node);

  const image = new Image();
  image.src = picture.getAttribute('js-lazy');

  const imageHandler = () => {
    picture.style.backgroundImage = `url(${image.src})`;
    picture.removeAttribute('js-lazy');
    img.removeAttribute('js-lazy');

    image.removeEventListener('load', imageHandler);
    img.src = image.src;

    if (anim === 'picture') pictureAnim(el.node);
    if (anim === 'sponsorLogo') sponsorLogo(el.node);
  };

  image.addEventListener('load', imageHandler);
};

export default pictureIn;
